import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Container, Form } from 'react-bootstrap';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { LOADING_STATUS } from '../../common/constants';
import { ActionButtons, Loader, SectionHeader } from '../../common/components';
import {
  addAddonDefinitionDataAsync,
  AddonDefinitionDetailsData,
  AddOnTranslations,
  getAddonDefinitionDetailsAsync,
  selectAccommodationAddonDetails,
  selectAccommodationAddOnDetailsLoadingStatus,
  updateAddonDefinitionDataAsync,
} from './addonSlice';

function AddNew() {
  const backLinkUrl = '/accommodations/addondefinitions';
  const navigate = useNavigate();
  const params = useParams();
  const [submitted, setSubmitted] = useState(false);
  const dispatch = useAppDispatch();
  // const addOnDetails = useAppSelector(selectAccommodationAddonDetails);
  const addonDetailsLoadingStatus = useAppSelector(
    selectAccommodationAddOnDetailsLoadingStatus,
  );
  const [addOnDetailsTemp, setaddOnDetailsTemp] = useState({
    id: 'new',
    translations: [],
  } as AddonDefinitionDetailsData);

  function getItem(locale, keyId, item) {
    if (
      item !== null &&
      item.translations !== null &&
      addonDetailsLoadingStatus === LOADING_STATUS.IDLE
    ) {
      const found = item.translations.filter(
        a => a.locale === locale && a.keyId === keyId,
      );
      if (found && found[0] && found[0].text) {
        return found[0].text;
      }
    }
    return '';
  }

  const handleInputChange = event => {
    const { target } = event;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    setaddOnDetailsTemp({ ...addOnDetailsTemp, [name]: value });
    setSubmitted(false);
  };

  const editTranslations = (translations, keyId, locale, value) => {
    let exist = false;

    translations = translations.map(item => {
      const temp = item;
      if (temp.keyId === keyId && temp.locale === locale) {
        const temp2 = { ...temp, text: value };
        exist = true;
        return temp2;
      }
      return item;
    });
    if (!exist) {
      const newitem: AddOnTranslations = {
        locale,
        keyId,
        text: value,
      };
      translations = [...translations, newitem];
      return translations;
    }
    return translations;
  };

  const handleInputChangeTranslation = event => {
    const { target } = event;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { id } = target;
    const { name } = target;
    let translationsTemp = addOnDetailsTemp.translations;
    if (id.endsWith('FiFi')) {
      translationsTemp = editTranslations(
        translationsTemp,
        name,
        'fi_FI',
        value,
      );
    } else if (id.endsWith('EnEn')) {
      translationsTemp = editTranslations(
        translationsTemp,
        name,
        'en_EN',
        value,
      );
    } else if (id.endsWith('RuRu')) {
      translationsTemp = editTranslations(
        translationsTemp,
        name,
        'ru_RU',
        value,
      );
    }

    const storeAddonDetails = { ...addOnDetailsTemp };
    storeAddonDetails.translations = translationsTemp;
    setaddOnDetailsTemp(storeAddonDetails);
    setSubmitted(true);
  };

  function getUpdateData(tempData) {
    const updateAddonData: AddonDefinitionDetailsData = {
      id: 'new',
      number: '',
      isRemoved: false,
      translations: tempData.translations,
      byPassOwnerPurchase: false,
    };

    return updateAddonData;
  }

  const updateAddon = event => {
    const data = getUpdateData(addOnDetailsTemp);
    if (params.addonId === 'new') {
      dispatch(addAddonDefinitionDataAsync(data)).then(response => {
        console.log('response', response, params.addonId);
        navigate(`/accommodations/addondefinitions/${response.payload}`);
      });
    } else {
      dispatch(addAddonDefinitionDataAsync(data)).then(response => {
        console.log('response 2', response, params.addonId);
        navigate(`/accommodations/addondefinitions/${response.payload}`);
      });
    }
  };

  const initFetch = useCallback(() => {
    if (params.addonId === 'new') {
      const newAddOnData: AddonDefinitionDetailsData = {
        id: 'new',
        number: '',
        isRemoved: false,
        byPassOwnerPurchase: false,
        translations: [
          { keyId: 'AddOnName', locale: 'fi_FI', text: 'Nimi FI' },
          { keyId: 'AddOnName', locale: 'en_EN', text: 'Nimi EN' },
          { keyId: 'AddOnName', locale: 'ru_RU', text: 'Nimi RU' },
        ],
      };
      setaddOnDetailsTemp(newAddOnData);
    } else {
      dispatch(getAddonDefinitionDetailsAsync(params.addonId));
    }
  }, [dispatch, params.addonId]);

  useEffect(() => {
    initFetch();
    if (params.addonId === 'new') {
      const newAddOnData: AddonDefinitionDetailsData = {
        id: 'new',
        number: '',
        isRemoved: false,
        byPassOwnerPurchase: false,
        translations: [
          { keyId: 'AddOnName', locale: 'fi_FI', text: 'Nimi FI' },
          { keyId: 'AddOnName', locale: 'en_EN', text: 'Nimi EN' },
          { keyId: 'AddOnName', locale: 'ru_RU', text: 'Nimi RU' },
        ],
      };
      setaddOnDetailsTemp(newAddOnData);
    }
  }, [initFetch]);

  return (
    <>
      <Helmet>
        <title>Lisäpalvelu - tiedot</title>
      </Helmet>

      <Container className="container-content">
        <SectionHeader
          BackLink={backLinkUrl}
          Breadcrumbs={['Majoitukset ja Ryhmät', 'Lisäpalveluiden määritykset']}
          Title={getItem('fi_FI', 'AddOnName', addOnDetailsTemp)}
        />

        <Loader
          IsLoading={addonDetailsLoadingStatus === LOADING_STATUS.LOADING}
        />

        {addonDetailsLoadingStatus === LOADING_STATUS.IDLE && (
          <Container className="container-form mt-48">
            <Form.Group className="mb-40">
              <Form.Label className="required" htmlFor="AddOnNameFiFi">
                Kuvaus FI
              </Form.Label>
              <Form.Control
                autoComplete="off"
                as="textarea"
                id="AddOnNameFiFi"
                required
                value={getItem('fi_FI', 'AddOnName', addOnDetailsTemp)}
                placeholder={getItem('fi_FI', 'AddOnName', addOnDetailsTemp)}
                onChange={handleInputChangeTranslation}
                name="AddOnName"
              />
            </Form.Group>

            <Form.Group className="mb-40">
              <Form.Label className="required" htmlFor="AddOnNameEnEn">
                Kuvaus EN
              </Form.Label>
              <Form.Control
                autoComplete="off"
                as="textarea"
                id="AddOnNameEnEn"
                required
                value={getItem('en_EN', 'AddOnName', addOnDetailsTemp)}
                placeholder={getItem('en_EN', 'AddOnName', addOnDetailsTemp)}
                onChange={handleInputChangeTranslation}
                name="AddOnName"
              />
            </Form.Group>

            {/* <Form.Group className="mb-40"> */}
            {/*  <Form.Label className="required" htmlFor="AddOnNameRuRu"> */}
            {/*    Kuvaus RU */}
            {/*  </Form.Label> */}
            {/*  <Form.Control */}
            {/*    autoComplete="off" */}
            {/*    as="textarea" */}
            {/*    id="AddOnNameRuRu" */}
            {/*    required */}
            {/*    value={getItem('ru_RU', 'AddOnName', addOnDetailsTemp)} */}
            {/*    placeholder={getItem('ru_RU', 'AddOnName', addOnDetailsTemp)} */}
            {/*    onChange={handleInputChangeTranslation} */}
            {/*    name="AddOnName" */}
            {/*  /> */}
            {/* </Form.Group> */}

            <ActionButtons
              CancelButtonUrl={backLinkUrl}
              HandleSave={updateAddon}
            />
          </Container>
        )}
      </Container>
    </>
  );
}

export default AddNew;
